var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@mui/material';
var stepMessageMap = {
    '12': "Beau progrès — n'abandonnez pas maintenant.",
    '19': 'Continuez ! Vous avez presque terminé le test.',
};
export function EncouragementNotes(_a) {
    var id = _a.id;
    if (!id || !stepMessageMap[id])
        return null;
    return _jsx(_Fragment, { children: stepMessageMap[id] });
}
var infoMessage = {
    '1': 'Saisissez au moins 3 chiffres, puis cliquez sur Envoyer.',
};
export function InfoMessage(_a) {
    var id = _a.id, error = _a.error;
    var message = error || (id && infoMessage[id]) || (id && stepMessageMap[id]);
    if (!message)
        return null;
    var isError = Boolean(error);
    var isInfo = !error && Boolean(id && infoMessage[id]);
    return (_jsx(Typography, __assign({ className: isError || isInfo
            ? 'font-bold text-red inline-block'
            : 'font-bold inline-block' }, { children: message })));
}
